import { render, staticRenderFns } from "./admin-estates-item-remove.vue?vue&type=template&id=2810b6f4&scoped=true"
import script from "./admin-estates-item-remove.vue?vue&type=script&lang=js"
export * from "./admin-estates-item-remove.vue?vue&type=script&lang=js"
import style0 from "./admin-estates-item-remove.vue?vue&type=style&index=0&id=2810b6f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810b6f4",
  null
  
)

export default component.exports